import React, { useState } from "react";
import { Card, TabsRow, TabButton } from "./styledComponents";
import VirtualWalletSendForm from "../../SendPage/component/VirtualWalletSendForm";
import BankWalletSendForm from "../../SendPage/component/BankWalletSendForm";
import OnchainWalletSendForm from "../../SendPage/component/OnchainWalletSendForm";

function SendWithdrawCard({ lastWallet }) {
  const [activeTab, setActiveTab] = useState("virtual_wallet");

  return (
    <Card>
      <h3 style={{ marginBottom: 4 }}>Withdraw</h3>
      <p style={{ color: "#94a3b8", fontSize: 12, marginTop: 0 }}>
        Transfer funds from your wallets to external addresses or other wallets.
      </p>

      <TabsRow>
        <TabButton
          active={activeTab === "virtual_wallet"}
          onClick={() => setActiveTab("virtual_wallet")}
        >
          Virtual Wallet
        </TabButton>
        <TabButton
          active={activeTab === "bank_wallet"}
          onClick={() => setActiveTab("bank_wallet")}
        >
          Bank Wallet
        </TabButton>
        <TabButton
          active={activeTab === "onchain_wallet"}
          onClick={() => setActiveTab("onchain_wallet")}
        >
          OnChain Wallet
        </TabButton>
      </TabsRow>

      <div style={{ marginTop: 20 }}>
        {activeTab === "virtual_wallet" && (
          <VirtualWalletSendForm walletOption="main_wallet" />
        )}
        {activeTab === "bank_wallet" && (
          <BankWalletSendForm />
        )}
        {activeTab === "onchain_wallet" && (
          <OnchainWalletSendForm walletOption="sub_wallet" />
        )}
      </div>
    </Card>
  );
}

export default SendWithdrawCard;

